import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=deec49ae&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=deec49ae&prod&lang=css&scoped=true"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=deec49ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec49ae",
  null
  
)

export default component.exports